import React from 'react'

// Импортируем SVG как URL
import ChartBarVertical from '../../icons/cooliocns SVG/Interface/Chart_Bar_Vertical_01.svg'
import UsersGroup from '../../icons/cooliocns SVG/User/Users_Group.svg'
import Building from '../../icons/cooliocns SVG/Navigation/Building_01.svg'
import CarAuto from '../../icons/cooliocns SVG/Navigation/Car_Auto.svg'
import Show from '../../icons/cooliocns SVG/Edit/Show.svg'
import Chat from '../../icons/cooliocns SVG/Communication/Chat.svg'
import Mail from '../../icons/cooliocns SVG/Communication/Mail.svg'
import Phone from '../../icons/cooliocns SVG/Communication/Phone.svg'
import EditPencil from '../../icons/cooliocns SVG/Edit/Edit_Pencil_01.svg'
import Trash from '../../icons/cooliocns SVG/Interface/Trash_Full.svg'
import Book from '../../icons/cooliocns SVG/Interface/Book.svg'
import Settings from '../../icons/cooliocns SVG/Interface/Settings.svg'
import Lock from '../../icons/cooliocns SVG/Interface/Lock.svg'
import GridBig from '../../icons/cooliocns SVG/Menu/More_Grid_Big.svg'
import MenuAlt from '../../icons/cooliocns SVG/Menu/Menu_Alt_01.svg'
import Reload from '../../icons/cooliocns SVG/Arrow/Arrow_Reload_02.svg'
import Hide from '../../icons/cooliocns SVG/Edit/Hide.svg'
import ChevronDown from '../../icons/cooliocns SVG/Arrow/Chevron_Down.svg'
import ChevronUp from '../../icons/cooliocns SVG/Arrow/Chevron_Up.svg'
import ChevronLeft from '../../icons/cooliocns SVG/Arrow/Chevron_Left.svg'
import ChevronRight from '../../icons/cooliocns SVG/Arrow/Chevron_Right.svg'
import Exit from '../../icons/cooliocns SVG/Interface/Exit.svg'
import Warning from '../../icons/cooliocns SVG/Warning/Warning.svg'
import CircleHelp from '../../icons/cooliocns SVG/Warning/Circle_Help.svg'
import File from '../../icons/cooliocns SVG/File/File_Document.svg'
import FileCheck from '../../icons/cooliocns SVG/File/File_Check.svg'
import CheckBig from '../../icons/cooliocns SVG/Interface/Check_Big.svg'
import Calendar from '../../icons/cooliocns SVG/Calendar/Calendar.svg'
import UserCardId from '../../icons/cooliocns SVG/User/User_Card_ID.svg'
import Search from '../../icons/cooliocns SVG/Interface/Search_Magnifying_Glass.svg'
import ArrowDown from '../../icons/cooliocns SVG/Arrow/Arrow_Down_LG.svg'
import PlayCircle from '../../icons/cooliocns SVG/Media/Play_Circle.svg'
import Pause from '../../icons/cooliocns SVG/Media/Pause.svg'
import CloseMD from '../../icons/cooliocns SVG/Menu/Close_MD.svg'
import Expand from '../../icons/cooliocns SVG/Arrow/Expand.svg'
import AddPlus from '../../icons/cooliocns SVG/Edit/Add_Plus.svg'
import Printer from '../../icons/cooliocns SVG/System/Printer.svg'

// Маппинг имен иконок на URL
const iconMap = {
  dashboard: ChartBarVertical,
  chart: ChartBarVertical,
  users: UsersGroup,
  userCardId: UserCardId,
  user_card_id: UserCardId,
  team: UsersGroup,
  building: Building,
  department: Building,
  car: CarAuto,
  parking: CarAuto,
  view: Show,
  eye: Show,
  check: CheckBig,
  checkmark: CheckBig,
  done: CheckBig,
  chat: Chat,
  message: Chat,
  mail: Mail,
  email: Mail,
  phone: Phone,
  edit: EditPencil,
  pencil: EditPencil,
  delete: Trash,
  trash: Trash,
  sync: Reload,
  refresh: Reload,
  reload: Reload,
  book: Book,
  reference: Book,
  settings: Settings,
  config: Settings,
  lock: Lock,
  security: Lock,
  grid: GridBig,
  cards: GridBig,
  menu: MenuAlt,
  table: MenuAlt,
  list: MenuAlt,
  hide: Hide,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevron: ChevronRight,
  exit: Exit,
  logout: Exit,
  signOut: Exit,
  warning: Warning,
  help: CircleHelp,
  question: CircleHelp,
  file: File,
  'file-check': FileCheck,
  'fileCheck': FileCheck,
  act: FileCheck,
  acts: FileCheck,
  calendar: Calendar,
  search: Search,
  download: ArrowDown,
  export: ArrowDown,
  info: File,
  play: PlayCircle,
  pause: Pause,
  close: CloseMD,
  x: CloseMD,
  expand: Expand,
  plus: AddPlus,
  add: AddPlus,
  print: Printer,
  printer: Printer,
  /** Отправка / далее (стрелка вправо) */
  send: ChevronRight,
}

function Icon({ name, size = 20, className = '', style = {}, ...rest }) {
  // Сначала пробуем найти по точному совпадению, затем по lowercase
  const iconSrc = iconMap[name] || iconMap[name?.toLowerCase()]

  if (!iconSrc) {
    if (import.meta.env.DEV) {
      console.warn(`Icon "${name}" not found`)
    }
    return null
  }

  return (
    <img
      src={iconSrc}
      alt={name}
      width={size}
      height={size}
      className={className}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        ...style
      }}
      {...rest}
    />
  )
}

export default Icon
